<!-- 视频播放特效 -->

<template>
  <div class="video-fully-loaded-player" :class="computedClass">
    <video ref="videoRef" class="fullscreen-video" preload="auto" :autoplay="autoplay" :muted="muted" :loop="loop"
      playsinline webkit-playsinline x5-playsinline x5-video-player-type="h5" x5-video-player-fullscreen="true">
      <source :src="video" type="video/mp4" />
    </video>
    <button v-if="showSkip && canSkip && isPlaying" class="btn-skip" @click="skip">
      跳过 ▶
    </button>
    <div class="reward f-center grow-animation" v-if="item_id">
        <TxImage :src="activity_config.item_data[item_id].icon_2"/>
        <span class="t-white">{{activity_config.item_data[item_id].name}}</span>
    </div>
  </div>
</template>
<script setup>
import { onMounted, shallowRef } from 'vue';
const {activity_config } = inject('GlobalStore');
const props = defineProps({
  autoplay: { type: Boolean, default: false },
  loop: { type: Boolean, default: false },
  muted: { type: Boolean, default: true },
  showSkip: { type: Boolean, default: true },
  skipDelay: { type: Number, default: 1000 },
  video: { type: String, required: true },
  item_id:{type:String,}
});

const emit = defineEmits([
  'ready', // 元数据就绪
  'fully-loaded', // 🔥 所有视频数据已加载完毕
  'play',
  'pause',
  'ended',
  'skip',
]);
// 状态
const videoRef = shallowRef(null);
const isReady = shallowRef(false); // metadata 加载完成
const isFullyLoaded = shallowRef(false); // 整个视频数据是否全部加载完毕
const isPlaying = shallowRef(false);
const canSkip = shallowRef(false);

// 播放控制
const play = async () => {
  const video = videoRef.value;
  if (!video) return;
  video.currentTime = 0;
  try {
    await video.play();
    isPlaying.value = true;
    emit('play');
  } catch (err) {
    console.warn('Play failed:', err);
  }
};

const pause = () => {
  const video = videoRef.value;
  if (video && !video.paused) {
    video.pause();
    isPlaying.value = false;
    video.currentTime = 0;
    emit('pause');
  }
};

const skip = () => {
  canSkip.value = false;
  pause();
  emit('skip');
  emit('ended');
};

// 判断是否全部加载完成
const checkIfFullyLoaded = () => {
  const video = videoRef.value;
  if (!video || !video.buffered || !video.duration) return;

  const buffered = video.buffered;
  const duration = video.duration;

  // 检查是否有缓冲段落覆盖了整个视频时长
  if (buffered.length > 0) {
    const end = buffered.end(buffered.length - 1); // 最后一段缓冲的结束时间
    if (end >= duration) {
      if (!isFullyLoaded.value) {
        isFullyLoaded.value = true;
        emit('fully-loaded'); // ✅ 触发“全部加载完成”事件
      }
    }
  }
};

onMounted(() => {
  const video = videoRef.value;
  if (!video) return;

  // 1. 元数据加载完成
  video.addEventListener('loadedmetadata', () => {
    isReady.value = true;
    emit('ready');
    if (props.autoplay) {
      setTimeout(play, 50);
    }
  });

  // 2. 监听 progress 事件（只有在浏览器持续下载时才触发）
  video.addEventListener('progress', () => {
    checkIfFullyLoaded();
  });

  // 3. 再次检查（某些情况下 progress 不够频繁）
  const interval = setInterval(checkIfFullyLoaded, 500);
  video.addEventListener('ended', () => {
    clearInterval(interval);
    isPlaying.value = false;
    canSkip.value = false;
    emit('ended');
  });
  video.addEventListener('pause', () => {
    isPlaying.value = false;
  });
  video.addEventListener('play', () => {
    isPlaying.value = true;
    set_timer();
  });
  onUnmounted(() => {
    clearInterval(interval);
  });
});
const computedClass = computed(() => {
  if (isPlaying.value) {
    return 'video_effect_play';
  } else {
    return '';
  }
});

function set_timer() {
  if (props.showSkip && props.skipDelay > 0) {
    setTimeout(() => {
      canSkip.value = true;
    }, props.skipDelay);
  }
}

defineExpose({
  play,
});
</script>
<style scoped lang="scss">
.video-fully-loaded-player {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: -1;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  visibility: hidden;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 10px;
}

.fullscreen-video {
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  object-fit: cover;
  object-position: center;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.btn-skip {
  position: absolute;
  top: 20px;
  right: 20px;
  padding: 10px 18px;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  font-size: 25px;
  transition: 0.3s;
  z-index: 5;
}

.btn-skip:hover {
  background: white;
  color: black;
  transform: scale(1.1);
}

.video_effect_play {
  visibility: visible;
  z-index: 9999;
}
.reward{
  position: absolute;
  top: 450px;
  opacity: 0;
}
</style>
